import { Exercise } from "./exerciseService";

export function getExerciseThumbnail (exercise: Exercise) {
    return exercise.thumbnailURL || 'https://www.creaza.com/file/ci/' + exercise.contentId + '/thumb/' + exercise.name;
}